import firebase from 'firebase/app'
import 'firebase/auth';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || ''
};

firebase.initializeApp(config);

export function createUserWithEmailAndPassword(email, password) {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(resolve)
      .catch(reject);
  });
}

export function signInWithEmailAndPassword(email, password) {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(resolve)
      .catch(reject);
  });
}

export function signOut(email, password) {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signOut()
      .then(resolve)
      .catch(reject);
  });
}

export function sendPasswordResetEmail(email) {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(resolve)
      .catch(reject);
  });
}

export function onAuthStateChanged(f) {
  const unsubscribe = firebase
    .auth()
    .onAuthStateChanged(f);
  return unsubscribe;
}



// WEBPACK FOOTER //
// ./src/services/FirebaseService.js